import { render, staticRenderFns } from "./UploadDocumentYardModal.vue?vue&type=template&id=15e99ba4&"
import script from "./UploadDocumentYardModal.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentYardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports